import { render, staticRenderFns } from "./TopicPostMenu.vue?vue&type=template&id=a535de42&scoped=true&"
import script from "./TopicPostMenu.vue?vue&type=script&lang=js&"
export * from "./TopicPostMenu.vue?vue&type=script&lang=js&"
import style0 from "./TopicPostMenu.vue?vue&type=style&index=0&id=a535de42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a535de42",
  null
  
)

export default component.exports